import DOMReady from '../utils/DomReady';
import AjaxRequest from '../utils/AjaxRequest';

DOMReady(() => {
  if (window.location.href.includes('/billing_information')) {
    const subscriptionContainer = document.querySelector('.js-hayden-profile__subscriptions');
    if (subscriptionContainer !== null) {
      const profileId = subscriptionContainer.dataset.id;
      const profileSlug = subscriptionContainer.dataset.slug;
      AjaxRequest(`/professionals/api/expert_profiles/${profileId}/billing_information`, { method: 'GET' }, (response) => {
        // Load subscription information
        document.querySelector('.js-hayden-profile__loading-subscriptions').style.display = 'none';
        response.transactions.table.transactions.forEach( tx => {
          // Items are: Plan, Status, Pricing, Date
          const plan = document.getElementById('subscription-plan');
          const planText = document.createTextNode(tx.table.id);
          plan.appendChild(planText);

          const status = document.getElementById('subscription-status');
          const statusText = document.createTextNode(tx.table.status);
          status.appendChild(statusText);

          const pricing = document.getElementById('subscription-pricing');
          const pricingText = document.createTextNode(`${tx.table.amount_with_breakdown.table.gross_amount.table.value} ${tx.table.amount_with_breakdown.table.gross_amount.table.currency_code}`);
          pricing.appendChild(pricingText);

          const startDate = document.getElementById('subscription-start-date');
          const startDateText = document.createTextNode(tx.table.time);
          startDate.appendChild(startDateText);
        });
        // Now, we show the container
        subscriptionContainer.classList.remove('afd-hide');
      }, (error) => {
        // show error message if something failed to load
        if (error && error.status === 404) {
          document.querySelector('.js-hayden-profile__loading-subscriptions').style.display = 'none';
          document.querySelector(".js-hayden-profile__no-subscriptions").classList.remove("afd-hide");
        }
      });
    }
  }
});
